import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from '@admin/redux';

import { createAxiosResources } from './api';
import { loadGoogleMapsApi } from './google_maps';
import { createPusherService } from './pusher_service';

export const createOpsMapStore = () => {
  const pusherService = createPusherService();
  const googleMapsApi = loadGoogleMapsApi();

  const extraArgument = {
    uiGmapGoogleMapApi: googleMapsApi,
    $state: {
      go: () => Promise.resolve(),
      href: () => '',
    },
    services: {
      PusherService: pusherService,
      UserService: window.clutter.user,
    },
    resources: createAxiosResources(),
    $rootScope: {
      $broadcast: () => undefined,
    },
  };

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancer = composeEnhancers(applyMiddleware(thunk.withExtraArgument(extraArgument)));

  return createStore(rootReducer, window.REDUX_STATE || {}, enhancer);
};
